/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-17 15:08:05
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-20 16:14:03
 * @FilePath: /dsicm-admin-web/src/views/scoentific/api/index.js
 */
import request from '@/utils/req.js';

//研究项目信息表列表查询
export function apiIesearchItemList(params = {}) {
    return request.post("/admin/research-item/list",params);
}
//研究项目新增
export function apiInsert(params) {
    return request.post("/admin/research-item/insert",params);
}

//研究项目修改
export function apiPutIesearchItem(params) {
    return request.put("/admin/research-item",params);
}

//科研团队列表查询
export function apiIesearchList(params = {}) {
    return request.post("/admin/research-team/list",params);
}

//科研团队新增
export function apiIesearchTeam(params) {
    return request.post("/admin/research-team/insert",params);
}

//科研团队修改
export function apiPutIesearchTeam(params) {
    return request.put("/admin/research-team",params);
}
//标准数据库分类表列表查询
export function apistandardCategory(params) {
    return request.post("/admin/standard-category/list",params);
}
//科研团队列表查询
export function apiApplyItem(params) {
    return request.post("/admin/apply-item/page",params);
}

//科研团队信息分页查询
export function getTeamMemberList(params) {
    return request.post("/admin/apply-item/getTeamMemberList",params);
}

//科研事件列表查询
export function apiResearchEvent(params) {
    return request.post("/admin/research_event/list",params);
}

//科研事件新增
export function apiResearchEventInsert(params) {
    return request.post("/admin/research_event/insert",params);
}

//科研事件编辑
export function apiResearchEventUpdate(params) {
    return request.post("/admin/research_event/update",params);
}

//科研事件删除
export function apiResearchEventRemove(params) {
    return request.delete(`/admin/research_event/${params}`);
}